import { render, staticRenderFns } from "./ws6-person-static.vue?vue&type=template&id=528c452f"
import script from "./ws6-person-static.vue?vue&type=script&lang=js"
export * from "./ws6-person-static.vue?vue&type=script&lang=js"
import style0 from "./ws6-person-static.vue?vue&type=style&index=0&id=528c452f&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports